import type { PurchaseEventParams } from "./googleAnalytics";

declare global {
    interface Window {
        uetq: UetQueue;
        UET: new (config: { ti: string; q?: UetQueue }) => UetQueue;
    }
}

type UetQueue = {
    push: (...args: unknown[]) => void;
};

let initializedTagId: string | null = null;

export function parseBingUetTagId(configValue: string | undefined | null): string | null {
    const id = configValue?.trim();
    return id ? id : null;
}

export function initBingUet(tagId: string): void {
    if (!tagId) return;
    if (initializedTagId === tagId) return;
    initializedTagId = tagId;

    const w = window;
    const d = document;
    const u = "uetq";

    w[u] = w[u] || [];

    const initUet = () => {
        if (!w.UET) return;
        const queue = w[u];
        w[u] = new w.UET({ ti: tagId, q: queue });
    };

    const script = d.createElement("script");
    script.async = true;
    script.src = "https://bat.bing.com/bat.js";
    script.onload = () => initUet();
    d.head.appendChild(script);
}

export function trackQuotePageView(pagePath: string): void {
    if (!window.uetq?.push) return;

    const pageSlug = pagePath.replace(/\/+$/, "").split("/").pop() || "quote";

    window.uetq.push("pageLoad");
    window.uetq.push("event", "page_view", {
        event_category: "quote",
        event_label: pageSlug,
        page_path: pagePath,
    });
}

export function trackPurchase(params: PurchaseEventParams): void {
    if (!window.uetq?.push) return;

    window.uetq.push("event", "purchase", {
        event_category: "insurance",
        event_label: params.baseCoverName,
        revenue_value: params.value,
        currency: params.currency,
        transaction_id: params.transactionId,
        base_cover_price: params.baseCoverValue,
    });
}
